import { pushEvent } from "@wbly/common";
import type { DataLayer } from "@wbly/common";

export const trackVideoPause = (
  video: HTMLVideoElement,
  videoSlug: string | null
) =>
  pushEvent(
    window.dataLayer as DataLayer[],
    `pdp_video, ${videoSlug}`,
    "paused",
    "time_watched_pct",
    (video?.currentTime / video?.duration).toFixed(2)
  );

export const trackVideoPlay = (
  video: HTMLVideoElement,
  videoSlug: string | null
) =>
  pushEvent(
    window.dataLayer as DataLayer[],
    `pdp_video, ${videoSlug}`,
    "started_playing_again",
    "time_started_pct",
    (video.currentTime / video.duration).toFixed(2)
  );
